export const AAD_B2C_TENANT = process.env.REACT_APP_AAD_B2C_TENANT
export const AAD_B2C_SIGN_IN_POLICY = process.env.REACT_APP_AAD_B2C_SIGN_IN_POLICY
export const AAD_B2C_APPLICATION_ID = process.env.REACT_APP_AAD_B2C_APPLICATION_ID
export const SERVER_GRAPHQL_ENDPOINT = process.env.REACT_APP_SERVER_GRAPHQL_ENDPOINT
export const APPLICATION_INSIGHTS_IKEY = process.env.REACT_APP_APPLICATION_INSIGHTS_IKEY
export const API_TOKEN_SCOPE = process.env.REACT_APP_API_TOKEN_SCOPE
